import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { selectDependentFormUserData } from '../../../redux/dependentForm/selectors';
import styles from '../styles.styl';

const mapStateToProps = state => ({
  dependentFormUser: selectDependentFormUserData(state),
});

export const enhance = compose(
  connect(mapStateToProps),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentDocuments/enhance.js